module.exports = __webpack_public_path__ + "img/mask_btom.db5585a7.png";